/******************************************************************************
 * App configuration
 *****************************************************************************/
export const APP_NAME = "Netzableseportal IVU GmbH";
export const APP_SHORT_NAME = "Netzableseportal";
export const APP_DESCRIPTION =
    "Melden Sie uns einfach online Ihre Zählerstände - schnell, bequem, sicher.";
export const CLIENT_FULL = "IVU Informationssysteme GmbH";
export const CLIENT_SHORT = "IVU GmbH";
export const FALLBACK_PRECOMMA_DIGITS = 7;
export const URLS = {
    website: "https://www.ivugmbh.de",
    privacy: "https://www.ivugmbh.de/datenschutz",
    imprint: "https://www.ivugmbh.de/impressum",
};
export const LENGTH_IMPLAUSIBLE_REASON_OTHER = 200;
export const ERROR_MESSAGES = {
    error429: "😡 Zuviele Anfragen. Bitte versuchen Sie es in Kürze erneut.",
    error500:
        "😓 Beim Verarbeiten Ihrer Anfrage ist ein Fehler aufgetreten. Bitte kontaktieren Sie unseren Kundenservice.",
};
